import React from "react";

export default function AppPage({
  className = "",
  topbar = null,
  children,
}) {
  const classes = [
    "ds-app-page",
    !topbar ? "ds-app-page--without-topbar" : "",
    className,
  ].filter(Boolean).join(" ");

  return (
    <section className={classes}>
      {topbar}
      <div className="ds-app-page__workspace-slot">{children}</div>
    </section>
  );
}
